/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react';
import { useLocalisation } from '@3plearning/lingui-cdn';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import Isvg from 'react-inlinesvg';

import arrowIconUp from './assets/dropdownUp.svg';
import arrowIconDown from './assets/dropdownDown.svg';
import css from './rank-dropdown.scss';

const RankDropdown = ({ certificatesCount, options, setSelectedGems }) => {
    const { i18n } = useLocalisation();
    const all = i18n.t`Label - All`;
    const [show, setShow] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(true);
    const [selectedOptions, setSelectedOptions] = useState(
        options.map(() => true)
    );
    const [title, setTitle] = useState(all);
    const [downloadCount, setDownloadCount] = useState(certificatesCount);
    const dropdownRef = useRef();

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                if (show) {
                    setShow(false);
                    event.stopPropagation();
                } else {
                    setShow(true);
                }
            }
        };

        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [show]);

    const handleToggle = () => {
        setShow(!show);
    };
    const getButtonText = () => (
        <div className={css.text} key="rank-button" title={title}>
            {title} ({downloadCount})
        </div>
    );
    const toggleSelectAll = () => {
        const updatedSelect = !isAllSelected;
        setIsAllSelected(updatedSelect);
        if (updatedSelect) {
            setSelectedOptions(options.map(() => true));
            setDownloadCount(certificatesCount);
            setSelectedGems(options);
            setTitle(all);
        } else {
            setSelectedOptions(options.map(() => false));
            setDownloadCount(0);
            setSelectedGems([]);
            setTitle('');
        }
    };

    const convertToRoman = (num) => {
        if (num === 16) {
            return '∞';
        }
        const numberArr = [10, 9, 5, 4, 1];
        const RomanArr = ['X', 'IX', 'V', 'IV', 'I'];
        const result = [];

        const findElement = (e) => e <= num;

        while (num > 0) {
            const nextHighest = numberArr.find(findElement);

            if (nextHighest) {
                result.push(RomanArr[numberArr.indexOf(nextHighest)]);
                num -= nextHighest;
            }
        }
        return result.join('');
    };

    const selectOption = (isChecked, index) => {
        const updatedOptions = [
            ...selectedOptions.slice(0, index),
            isChecked,
            ...selectedOptions.slice(index + 1)
        ];
        setSelectedOptions(updatedOptions);
        if (!isChecked) {
            setIsAllSelected(false);
        } else {
            setIsAllSelected(updatedOptions.every((value) => value));
        }

        const newArray = options.filter(
            (opt, optIndex) => updatedOptions[optIndex] && opt.count > 0
        );
        const gemsTypes = newArray.map((item) => item.gem);
        setSelectedGems(newArray);
        setDownloadCount(newArray.reduce((acc, item) => acc + item.count, 0));
        setTitle(
            updatedOptions.every((value) => value)
                ? all
                : gemsTypes.map((item) => convertToRoman(item)).join(', ')
        );
    };

    return (
        <div className={css['dropdown-container']}>
            <div
                role="button"
                className={css['dropdown-trigger']}
                tabIndex={0}
                onClick={handleToggle}
            >
                {getButtonText()}
                <Isvg src={show ? arrowIconUp : arrowIconDown} />
            </div>

            {show && (
                <div
                    ref={dropdownRef}
                    className={css['dropdown-options-container']}
                >
                    <div className={css['dropdown-option']}>
                        <div>
                            <input
                                className={css['check-box']}
                                id={all}
                                name={all}
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={() => toggleSelectAll()}
                            />
                            <label htmlFor={all}>{all}</label>
                        </div>
                        <div>{certificatesCount}</div>
                    </div>
                    {options.map((option, index) => (
                        <div
                            className={css['dropdown-option']}
                            key={option.gem}
                        >
                            <div>
                                <input
                                    className={css['check-box']}
                                    id={option.gem}
                                    name={option.gem}
                                    type="checkbox"
                                    checked={selectedOptions[option.gem - 1]}
                                    disabled={option.count === 0}
                                    onChange={(e) =>
                                        selectOption(e.target.checked, index)
                                    }
                                />
                                <label htmlFor={option.gem}>
                                    {convertToRoman(option.gem)}
                                </label>
                            </div>
                            <div>{option.count}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

RankDropdown.propTypes = {
    certificatesCount: PropTypes.number.isRequired,
    options: PropTypes.array,
    setSelectedGems: PropTypes.func
};

export default styleable(css)(RankDropdown);



// WEBPACK FOOTER //
// ./components/certificates/components/rank-dropdown/rank-dropdown.js